import { render, staticRenderFns } from "./PurchasingProcesses.vue?vue&type=template&id=0618e728&scoped=true&"
import script from "./PurchasingProcesses.vue?vue&type=script&lang=js&"
export * from "./PurchasingProcesses.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingProcesses.vue?vue&type=style&index=0&id=0618e728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0618e728",
  null
  
)

export default component.exports